<div class="dialog confirm-dialog">
  <button mat-button mat-dialog-close class="dialog__close">
    <mat-icon aria-hidden="false" aria-label="Close icon">close</mat-icon><span>{{ 'shared.close' | translate }}</span>
  </button>
  <div mat-dialog-title>
    <h3 class="help">{{ 'shared.alert' | translate }}</h3>
    <div class="title-actions">
      <button id="e2e-close-dialog-btn" class="txt-button" (click)="onClose(false)"></button>
    </div>
  </div>
  <div mat-dialog-content>
    <p class="message">{{ message }}</p>
    <div mat-dialog-actions>
      <button class="btn-submit" (click)="onClose(true)">{{ 'shared.tryAgain' | translate }}</button>
    </div>
  </div>
</div>
